import { render, staticRenderFns } from "./RatingAnswer.vue?vue&type=template&id=50229162&"
import script from "./RatingAnswer.vue?vue&type=script&lang=js&"
export * from "./RatingAnswer.vue?vue&type=script&lang=js&"
import style0 from "./RatingAnswer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
